// extracted by mini-css-extract-plugin
export var des = "index-module--des--2o3m9";
export var split = "index-module--split--gnvFv";
export var title = "index-module--title--pWLVF";
export var wrapper = "index-module--wrapper--ewW0g";